export enum drawerActionType {
  TOGGLE_DRAWER = 'TOGGLE_DRAWER',
  TOGGLE_COLLAPSE = 'TOGGLE_COLLAPSE',
  REMOVE_COLLAPSE = 'REMOVE_COLLAPSE',
  CLOSE_DRAWER = 'CLOSE_DRAWER',
  SET_SELECTED_ITEM = 'SET_SELECTED_ITEM',
}
